import { onAuthStateChanged } from "firebase/auth";
import { doc, onSnapshot } from "firebase/firestore";
import { FirebaseAuth, FirestoreDB } from "utils/firebase";

export function subscribeMemoryChanges(onChange) {
  let unsubscribeState;
  let previousUid;
  let initialized = false;
  const unsubscribeAuth = onAuthStateChanged(FirebaseAuth, (user) => {
    unsubscribeState?.();
    if (initialized && previousUid !== user?.uid)
      onChange({ accountChanged: true });
    initialized = true;
    previousUid = user?.uid;
    if (!user) return;
    let revision;
    unsubscribeState = onSnapshot(
      doc(FirestoreDB, `users/${user.uid}/memoryState/current`),
      (snapshot) => {
        const data = snapshot.data() || {};
        const next = `${data.epoch || 0}:${data.revision || 0}:${Boolean(data.clearing)}`;
        if (revision !== undefined && next !== revision) onChange();
        revision = next;
      },
      () => {},
    );
  });
  return () => {
    unsubscribeAuth();
    unsubscribeState?.();
  };
}
